<template>
    <div class="">

        <div class="row w-100" v-if="extras.length > 0">
            <div class="col-sm-4">
                <label class="full">Service</label>
            </div>
            <div class="col-sm-3">
                <label class="full">Price</label>
            </div>
            <div class="col-sm-2">
                <label class="full">Tax</label>
            </div>
            <div class="col-sm-2">
                <label class="full">PVP</label>
            </div>
            <div class="col-sm-1">
                <label class="full">&nbsp;</label>
            </div>
        </div>

        <div v-if="priceObj">
            <div class="row w-100 mt-3" v-for="service, index in priceObj.productGenderPriceComponents" >
                <div class="col-sm-4">
                    <v-select
                        v-if="extras"
                        v-model="service.component"
                        :options="extras"
                        placeholder="- Select category -"
                        :searchable="true"
                        label="name"
                        @input="updateExtra(service, service.component)">
                    </v-select>
                </div>

                <div class="col-sm-3">
                    <v-select
                        v-if="extras"
                        v-model="service.component.selectedPrice"
                        :options="service.component.prices"
                        placeholder="- Select category -"
                        :searchable="true"
                        label="name"
                        @input="updateExtraPrice(service, $event)">
                    </v-select>
                </div>

                <div class="col-sm-2 pt-2">
                    <span v-if="service.component.selectedPrice && service.component.selectedPrice.vatType !== undefined">
                        {{taxIdToName(service.component.selectedPrice.vatType)}}
                    </span>
                </div>

                <div class="col-sm-2 pt-2">
                    <span v-if="service.component.selectedPrice">
                        {{service.component.selectedPrice.grossprice}} €
                    </span>
                </div>

                <div class="col-sm-1 pt-2">
                    <i class="ico-delete fs-large medium pointer m-0" @click="removePrice(index)"></i>
                </div>

            </div>
        </div>

        <div class="row d-flex justify-content-center text-center dark p-4" v-if="extras.length == 0">
            <span>✨ Looks like you have no services created, please create them <span class="bold underlined pointer" @click="createExtraClick">here</span>.</span>
        </div>

        <div v-else class="row mt-3 w-100">
            <div class="col-sm-12">
                <div class="add d-flex align-items-center pointer fs-small bold" @click="addRow">
                    <i class="ico-add fs-smallest add-circle color-1"></i> Add service
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
export default {
    data: function() {
        return {

        }
    },
    props: {
        // priceObj: {
        //     type: Object,
        //     default: function() {
        //         // this is used on create/edit product -> edit split price (modal that looks like a calculator)
        //         return this.getProductEditPriceData
        //     }
        // }
    },
    // asyncComputed: {
    //     async extras() {
    //         try {
    //             let response = await axios.get('/api/inventory/ListExtra', { params: { supplierId: this.account.supplierId }});
    //
    //             if (response && response.status === 200 && response.data && response.data.length > 0) {
    //
    //                 return response.data;
    //             }
    //         }
    //         catch (error) {
    //             this.$toasted.error(error);
    //         }
    //     }
    // },
    computed: {
        ...mapGetters([
            'account',
            'getProductEditPriceData',
            'getVatTypes',
            'getExtras',
        ]),
        priceObj: function () {
            return this.getProductEditPriceData
        },
        taxes: function () {
            return this.getVatTypes
        },
        extras: function() {
            return JSON.parse(JSON.stringify(this.getExtras))
        }
    },
    methods:{
        ...mapActions([
            'openModal',
            'updateroductEditPriceData'
        ]),
        createExtraClick: function () {
            this.openModal('ExtraAdd')
        },
        updateExtra: function(service, component) {
            if(service.component == null){
                service.component = JSON.parse(JSON.stringify(this.extras[0]))
            }
            this.updateRowToStore()
        },
        updateExtraPrice: function(service, e) {
            if(service.component.selectedPrice == null){
                service.component.selectedPrice = service.component.prices[0]
            } else {
                // this.$set(service.selectedPrice, selectedPrice)
                service.selectedPrice = e
            }
            this.updateRowToStore()
        },
        taxIdToName: function(taxId){
            if(this.taxes){
                return this.taxes.filter((tax) => {
                    return tax.id == taxId
                })[0].description
            }
        },
        removePrice: function(index) {
            this.priceObj.productGenderPriceComponents.splice(index, 1);
        },
        addRow: function() {
            let newRow = JSON.parse(JSON.stringify(this.extras[0]))
            newRow.selectedPrice = newRow.prices[0]
            let defaultRow = {
                "component": newRow,
                "isMandatory": 0
            }

            this.priceObj.productGenderPriceComponents.push(defaultRow)
        },
        updateRowToStore: function() {
            this.updateroductEditPriceData(this.priceObj)
        }
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SplitPriceEditor.vue?18cc125d